<template>
  <div class="test-info">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/test-record' }">答题记录</el-breadcrumb-item>
      <el-breadcrumb-item>答题详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="list">
      <p class="title">{{questionnaire_name}}</p>
      <p class="c_time">答题时间：{{c_time}}</p>
      <p class="c_time">用户名称：{{user_info.name}}</p>
      <p class="c_time">性别：{{user_info.gender}}</p>
      <p class="c_time">年龄：{{user_info.age}} 岁</p>
      <div class="item" v-for="(item, key) in tableData">
        <p>{{key + 1}}.{{item.question_content}}</p>
        <ul class="margin_left">
          <li v-for="item_option in item.option">{{item_option.content}}({{item_option.score}} 分)</li>
        </ul>
        <p class="margin_left">用户选择：<span class="user_answer">{{user_select(item.option,item.user_option_id)}}</span></p>
      </div>
      <div class="user_analysis">
        <p>用户得分：<span>{{score}}</span></p>
        <p  v-if="dimension_score.length">用户维度得分：</p>
        <ul v-if="dimension_score.length">
          <li v-for="item in dimension_score"><p>{{item.dimension}}：<span>{{item.score}}</span></p></li>
        </ul>
        <p>问卷反馈内容：{{feedback_content}}</p>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        questionnaire_name:'',
        score: 0,
        c_time:'',
        user_info:{},
        feedback_content: '',
        tableData: [],
        dimension_score:[]
      }
    },
    methods: {
      getInfo(){
        this.$get('/v1/questionnaire/answer-record-info?id=' + this.$route.query.id, {})
          .then((res) => {
            console.log(res)
            if (res.data.status === 'success') {
              this.questionnaire_name = res.data.data.data.questionnaire_name;
              this.score = res.data.data.data.score;
              this.c_time = res.data.data.data.c_time;
              this.user_info = res.data.data.user_info;
              this.feedback_content = res.data.data.data.feedback_content;
              this.tableData = res.data.data.data.question;
              this.dimension_score = res.data.data.data.dimension_score;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      user_select(option,user_option_id){
        return option.filter((option_item)=>{
          return option_item.id === user_option_id
        })[0].content
      },
      goTo(path,id){
        this.$router.push({
          path:path,
          query:{
            id:id
          }
        })
      }
    },
    created() {
      this.getInfo()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .test-info
    .list
      min-height 550px
      padding 16px 20px
      margin-top 20px
      border 1px solid #EBEEF5
      .title
        font-size 18px
        text-align center
        line-height 36px
      .c_time
        margin-bottom 16px
      .item
        padding-bottom 12px
        margin-bottom 10px
        border-bottom 1px dashed #ccc
        p
          font-size 14px
          font-weight 600
          .user_answer
            color blue
        ul
          display flex
          margin 8px 0
          li
            list-style none
            min-width 60px
            margin-right 40px
        .margin_left
          margin-left 10px


      .user_analysis
        width 100%
        margin-top 40px
        ul
          margin-left 20px
          p
            font-size 14px
            color #666
            span
              color #333
              font-size 18px
        p
          font-size 16px
          color #666
          line-height 36px
          span
            color blue
            font-size 20px

</style>



// WEBPACK FOOTER //
// src/pages/TestRecord/TestInfo.vue